import { render } from "./Cbhifacilitiespage.vue?vue&type=template&id=68f19134&scoped=true"
import script from "./Cbhifacilitiespage.vue?vue&type=script&lang=js"
export * from "./Cbhifacilitiespage.vue?vue&type=script&lang=js"

import "./Cbhifacilitiespage.vue?vue&type=style&index=0&id=68f19134&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f19134"]])

export default __exports__